<template>
  <div style="position: relative;">
    <balance-chart
      :config="config"
      :data="categoryData"
      :height="200"
      :is-loading="isLoading"
      :max-length="maxLength"
      :last-year-label="lastYearLabel"
      :y-max="yMax"
    />
  </div>
</template>
<script>
  import { BalanceChart } from 'frontend-packages'
  import { unzipWith, values, isPlainObject, pick, isArray, sum, constant, times, take, add } from 'lodash'

  const CHART_SUMMARY_CONFIG = [
    {
      name: 'fee_covered_by_income',
      text: '收入覆盖的支出',
      color: '#4AA0F8',
      list: ['fee_covered_by_income'],
      series: 'bar',
      stack: true,
      legend: true,
    },
    {
      name: 'fee_covered_by_deposit',
      text: '储蓄覆盖的支出',
      color: '#4AE1F8',
      list: ['fee_covered_by_deposit'],
      series: 'bar',
      stack: true,
      legend: true,
    },
    {
      name: 'fee_covered_by_certainty_compensation',
      text: '保险覆盖的支出',
      color: '#20E4AA',
      list: ['fee_covered_by_certainty_compensation'],
      series: 'bar',
      stack: true,
      legend: true,
    },
    {
      name: 'fee_covered_by_uncertainty_compensation',
      text: '保险覆盖部分支出',
      color: '#FFDF62',
      list: ['fee_covered_by_uncertainty_compensation'],
      series: 'bar',
      stack: true,
      legend: true,
    },
    {
      name: 'gap',
      text: '未被保障的支出',
      color: '#F43A50',
      list: ['gap'],
      series: 'bar',
      stack: true,
      legend: true,
    },
    {
      name: 'income',
      text: '家庭收入',
      series: 'line',
      list: ['family_annual_income'],
      legend: true,
    },
    // {
    //   name: 'pointLabel',
    //   text: '',
    //   list: [],
    //   func: function (row, yearIndex) {
    //     return `${yearIndex + 2019}年`
    //   }
    // },
    {
      name: 'shadow',
      text: '',
      list: ['shadow'],
    },
  ]

  export default {
    name: 'CustomServiceChart',
    components: {
      BalanceChart
    },
    props: {
      riskData: {
        type: Object,
        default: () => [],
      }
    },
    data: function () {
      return {

        categoryData: {},
        isLoading: true,
        maxLength: 0,
        config: CHART_SUMMARY_CONFIG,
        lastYearLabel: '',
        yMax: 0
      }
    },
    watch: {
      riskData: function () {
        this.updateChart()
      }
    },
    created: function () {
      this.init()
    },
    methods: {
      init: function () {
        if (this.riskData) {
          this.updateChart()
        }
      },
      updateChart: function() {
        const riskData = this.riskData

        const maxLength = riskData['fee_length']
        const chartData = {}
        this.yMax = riskData['max_amount']

        // 汇总费用
        for (let category of CHART_SUMMARY_CONFIG) {
          const { name, list } = category
          chartData[name] = unzipWith(
            values(pick(riskData, list)).map((item) => {
              if(isPlainObject(item)) {
                return unzipWith(values(item), (...array) => sum(array))
              } else if (item.length && isArray(item[0])) {
                return unzipWith(item , (...array) => sum(array))
              } else if (item.length) {
                return item
              } else {
                return []
              }
            }),
            add
          )
        }
        for (let name in chartData) {
          if (!chartData.hasOwnProperty(name)) continue
          chartData[name] = take(chartData[name], maxLength)
        }
        chartData['shadow'] = times(maxLength, constant(this.yMax))

        this.lastYearLabel = `${2019 + riskData['fee_length']}年${riskData['end_scene']}`
        this.categoryData = chartData
        this.maxLength = maxLength
        this.isLoading = false
      },
    }
  }
</script>
